import React from 'react';

export function SelectedOptionToTextWithOther(props: {
    selectedValue?: string | null | undefined;
    options: {
        text: string;
        value: string;
    }[];
    otherId: string;
    otherValue?: string | null | undefined;
}) {
    if (!props.selectedValue) {
        return null;
    }
    if (props.selectedValue === props.otherId) {
        return <>{props.otherValue}</>;
    }
    const option = props.options.find((i) => i.value === props.selectedValue);
    if (!option) {
        return <>{props.selectedValue}</>;
    }
    return <>{option.text}</>;
}
